import { type ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Label } from "./Label";

// Shared field wrapper for admin forms. Renders the label, the input
// (children), an optional hint, and an aria-describedby-linked error
// message under the field per ui-patterns.md + accessibility.md (errors
// below field, tied via aria-describedby).
export interface FormFieldProps {
  id: string;
  label: string;
  required?: boolean | undefined;
  hint?: string | undefined;
  error?: string | undefined;
  className?: string | undefined;
  children: ReactNode;
}

export function FormField({
  id,
  label,
  required,
  hint,
  error,
  className,
  children
}: FormFieldProps): JSX.Element {
  return (
    <div className={cn("space-y-1", className)}>
      <Label htmlFor={id}>
        {label}
        {required ? (
          <span className="ml-0.5 text-danger" aria-hidden="true">
            *
          </span>
        ) : null}
      </Label>
      {hint ? (
        <p id={`${id}-hint`} className="text-xs text-zinc-500">
          {hint}
        </p>
      ) : null}
      {children}
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-xs text-danger">
          {error}
        </p>
      ) : null}
    </div>
  );
}
